import React from 'react';
import { PlanFrequencyEnum } from '../../../../enum/frequency';
import { CommonPricingTranslations } from '../types';
import { Grid, GridCol, GridRow } from '../../../UI/Grid';
import { SliceContext } from '../../types';
import { CountryCurrency } from '../../../../helpers';
import { PricingPlan, PricingPlanDocument } from './PricingPlan';
import '../Pricing.scss';

export type PricingTabDocument = {
    uid: string;

    data: {
        name: string;
        plans: Array<{
            plan: {
                document: PricingPlanDocument[];
            };
        }>;
    };
};

export type PricingTabProps = {
    tab: PricingTabDocument;
    frequency: PlanFrequencyEnum;
    countryCurrency: CountryCurrency;
    commonTranslations: CommonPricingTranslations;
    sliceContext: SliceContext;
};

class PricingTab extends React.Component<PricingTabProps> {
    render() {
        return (
            <Grid className="PricingTab">
                <GridRow verticalAlign={'v-stretch'}>
                    {this.props.tab.data.plans.map((item, index) => (
                        <GridCol className="u-mb-4" colSize={'4'} mobileColSize={'12'} key={index}>
                            <PricingPlan
                                plan={item.plan.document[0]}
                                frequency={this.props.frequency}
                                countryCurrency={this.props.countryCurrency}
                                commonTranslations={this.props.commonTranslations}
                                sliceContext={this.props.sliceContext}
                            />
                        </GridCol>
                    ))}
                </GridRow>
            </Grid>
        );
    }
}

export { PricingTab };
